import i18n from 'config/i18n';

import { getLocale } from 'utils/date';

import { GridColDef } from '@mui/x-data-grid-pro';

const t = i18n.getFixedT(getLocale(), 'common');

const accountGroupColumnDefinitions = [
  {
    field: 'name',
    headerName: t('name'),
    type: 'string',
    flex: 1,
    align: 'left'
  }
] as GridColDef[];

export default accountGroupColumnDefinitions;
